import React from 'react';

function Footer() {
 
    return (
          
    <div className="footer">
        <p>Made with <span role="img" aria-label="heart">💖</span>by <a target="_blank" aria-label="Juni Portfolio" rel="noopener noreferrer"href="https://hellojuninguyen.netlify.app/">juniHUB</a> 2020</p>
    </div>
    )
}

export default Footer;
